import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import EditMenuPage from "./EditMenuPage";
import MenuListingPage from "./MenuListingPage";
import { withPermission, Roles } from "../../../util/PermissionProvider";

export default function MenuManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          MenuListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={withPermission(
          EditMenuPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
